var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAltWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 124,
    viewBox: "0 0 94 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.75 32.9375V0H6.3125C2.92188 0 0.5 2.66406 0.5 5.8125V118.188C0.5 121.578 2.92188 124 6.3125 124H87.6875C90.8359 124 93.5 121.578 93.5 118.188V38.75H60.5625C57.1719 38.75 54.75 36.3281 54.75 32.9375ZM70.25 90.0938C70.25 91.7891 68.7969 93 67.3438 93H26.6562C24.9609 93 23.75 91.7891 23.75 90.0938V88.1562C23.75 86.7031 24.9609 85.25 26.6562 85.25H67.3438C68.7969 85.25 70.25 86.7031 70.25 88.1562V90.0938ZM70.25 74.5938C70.25 76.2891 68.7969 77.5 67.3438 77.5H26.6562C24.9609 77.5 23.75 76.2891 23.75 74.5938V72.6562C23.75 71.2031 24.9609 69.75 26.6562 69.75H67.3438C68.7969 69.75 70.25 71.2031 70.25 72.6562V74.5938ZM70.25 57.1562V59.0938C70.25 60.7891 68.7969 62 67.3438 62H26.6562C24.9609 62 23.75 60.7891 23.75 59.0938V57.1562C23.75 55.7031 24.9609 54.25 26.6562 54.25H67.3438C68.7969 54.25 70.25 55.7031 70.25 57.1562ZM93.5 29.5469C93.5 28.0938 92.7734 26.6406 91.8047 25.4297L68.0703 1.69531C66.8594 0.726562 65.4062 0 63.9531 0H62.5V31H93.5V29.5469Z",
    fill: "#F4F5FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAltWhite);
export default __webpack_public_path__ + "static/media/file-alt-white.c4d095d2270761af09f7b250edcfd76a.svg";
export { ForwardRef as ReactComponent };